// INCIDENCIA #5 — Imágenes restauradas con fotos reales de especias por temática
export interface BundleProduct {
  id: number;
  name: string;
  image: string;
}

export interface Bundle {
  id: number;
  name: string;
  slug: string;
  tagline: string;
  description: string;
  image: string;
  products: BundleProduct[];
  originalPrice: string;
  bundlePrice: string;
  savings: string;
  badge?: string;
  theme: string;
  color: string;
  includes: string[];
  perfectFor: string[];
  rating: number;
  reviewCount: number;
}

const bundleFixtures: Bundle[] = [
  {
    id: 101,
    name: 'Pack Mediterráneo',
    slug: 'pack-mediterraneo',
    tagline: 'Los sabores del sur de Europa en tu cocina',
    description: 'Una selección cuidada de las hierbas y especias más emblemáticas de la cocina mediterránea. Desde el orégano silvestre griego hasta el romero provenzal, cada especia ha sido seleccionada por nuestros maestros especieros para ofrecerte la autenticidad del Mediterráneo.',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    products: [
      { id: 4, name: 'Albahaca Orgánica', image: '' },
      { id: 9, name: 'Orégano Silvestre Griego', image: '' },
      { id: 12, name: 'Romero Deshidratado', image: '' },
      { id: 15, name: 'Tomillo Limón Orgánico', image: '' },
      { id: 18, name: 'Hierbas Provenzales', image: '' },
    ],
    originalPrice: '34,95',
    bundlePrice: '26,99',
    savings: '7,96',
    badge: 'Más Vendido',
    theme: 'mediterranean',
    color: 'forest',
    includes: ['5 especias premium en tarros de cristal', 'Recetario mediterráneo exclusivo (PDF)', 'Guía de maridaje con vinos', 'Caja regalo de madera reciclada'],
    perfectFor: ['Paellas y arroces', 'Ensaladas frescas', 'Carnes a la brasa', 'Pastas y pizzas artesanales'],
    rating: 4.8,
    reviewCount: 6,
  },
  {
    id: 102,
    name: 'Pack Oriental',
    slug: 'pack-oriental',
    tagline: 'Viaja a Asia sin salir de tu cocina',
    description: 'Sumérgete en los aromas exóticos de Oriente con esta colección de especias asiáticas. Desde el jengibre fresco hasta el cardamomo verde, cada ingrediente te transportará a los mercados de especias de la India, Tailandia y China.',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    products: [
      { id: 2, name: 'Jengibre Premium', image: '' },
      { id: 7, name: 'Cúrcuma Orgánica', image: '' },
      { id: 14, name: 'Garam Masala', image: '' },
      { id: 17, name: 'Cardamomo Verde', image: '' },
      { id: 22, name: 'Especias Asiáticas Fusión', image: '' },
    ],
    originalPrice: '49,45',
    bundlePrice: '37,99',
    savings: '11,46',
    badge: 'Nuevo',
    theme: 'oriental',
    color: 'amber',
    includes: ['5 especias exóticas en tarros de cristal', 'Recetario asiático con 15 recetas', 'Guía de técnicas de cocina oriental', 'Caja regalo con diseño japonés'],
    perfectFor: ['Currys y woks', 'Sopas ramen y pho', 'Tés e infusiones', 'Postres orientales'],
    rating: 4.9,
    reviewCount: 5,
  },
  {
    id: 103,
    name: 'Pack Parrillero',
    slug: 'pack-parrillero',
    tagline: 'El secreto de las mejores barbacoas',
    description: 'Todo lo que necesitas para convertir tu barbacoa en una experiencia gourmet. Especias ahumadas, mezclas para rubs y hierbas aromáticas que elevarán tus carnes, pescados y verduras a la parrilla a otro nivel.',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    products: [
      { id: 5, name: 'Pimienta Negra Premium', image: '' },
      { id: 10, name: 'Pimentón Ahumado', image: '' },
      { id: 11, name: 'Especias para BBQ', image: '' },
      { id: 13, name: 'Comino Molido', image: '' },
      { id: 20, name: 'Chimichurri Argentino', image: '' },
    ],
    originalPrice: '41,95',
    bundlePrice: '31,99',
    savings: '9,96',
    theme: 'bbq',
    color: 'red',
    includes: ['5 especias ahumadas y aromáticas', 'Guía de tiempos y temperaturas BBQ', 'Recetas de rubs y marinados', 'Caja regalo estilo rústico'],
    perfectFor: ['Carnes rojas y costillas', 'Pollo y cerdo a la brasa', 'Verduras asadas', 'Hamburguesas gourmet'],
    rating: 4.7,
    reviewCount: 6,
  },
  {
    id: 104,
    name: 'Pack Repostería',
    slug: 'pack-reposteria',
    tagline: 'Dulzura natural en cada bocado',
    description: 'Las especias más selectas para tus creaciones dulces. Vainilla de Madagascar, canela de Ceilán y cardamomo verde se combinan para transformar tus postres en obras maestras aromáticas.',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    products: [
      { id: 8, name: 'Canela de Ceilán', image: '' },
      { id: 17, name: 'Cardamomo Verde', image: '' },
      { id: 21, name: 'Vainilla Bourbon', image: '' },
      { id: 23, name: 'Menta Piperita', image: '' },
    ],
    originalPrice: '34,96',
    bundlePrice: '27,49',
    savings: '7,47',
    badge: 'Edición Limitada',
    theme: 'pastry',
    color: 'rose',
    includes: ['4 especias dulces premium', 'Recetario de repostería con 12 recetas', 'Guía de combinaciones dulces', 'Caja regalo elegante'],
    perfectFor: ['Tartas y bizcochos', 'Galletas artesanales', 'Bebidas calientes', 'Helados caseros'],
    rating: 4.9,
    reviewCount: 4,
  },
  {
    id: 105,
    name: 'Pack Marroquí',
    slug: 'pack-marroqui',
    tagline: 'Los aromas mágicos del norte de África',
    description: 'Descubre la riqueza aromática de la cocina marroquí con esta colección de especias auténticas. Desde el ras el hanout hasta el comino, cada especia evoca los zocos de Marrakech y la tradición culinaria bereber.',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    products: [
      { id: 7, name: 'Cúrcuma Orgánica', image: '' },
      { id: 13, name: 'Comino Molido', image: '' },
      { id: 16, name: 'Especias Marroquíes', image: '' },
      { id: 19, name: 'Azafrán La Mancha', image: '' },
      { id: 24, name: 'Dukkah Egipcia', image: '' },
    ],
    originalPrice: '64,45',
    bundlePrice: '49,99',
    savings: '14,46',
    badge: 'Premium',
    theme: 'moroccan',
    color: 'amber',
    includes: ['5 especias norteafricanas selectas', 'Recetario marroquí con tajines y cuscús', 'Guía de preparación de té moruno', 'Caja regalo con motivos árabes'],
    perfectFor: ['Tajines y cuscús', 'Cordero y pollo especiado', 'Té moruno tradicional', 'Hummus y falafel'],
    rating: 4.8,
    reviewCount: 4,
  },
  {
    id: 106,
    name: 'Pack Iniciación',
    slug: 'pack-iniciacion',
    tagline: 'Tu primer paso en el mundo de las especias',
    description: 'El pack perfecto para quienes quieren empezar a explorar el fascinante mundo de las especias. Incluye las esenciales que no pueden faltar en ninguna cocina, con guías detalladas de uso para cada una.',
    image: 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images/packs/pack-iniciacion-image.jpg',
    products: [
      { id: 1, name: 'Hierbas Orgánicas', image: '' },
      { id: 4, name: 'Albahaca Orgánica', image: '' },
      { id: 5, name: 'Pimienta Negra', image: '' },
      { id: 9, name: 'Orégano Silvestre', image: '' },
      { id: 10, name: 'Pimentón Ahumado', image: '' },
      { id: 12, name: 'Romero Deshidratado', image: '' },
    ],
    originalPrice: '42,44',
    bundlePrice: '29,99',
    savings: '12,45',
    badge: 'Ideal Principiantes',
    theme: 'starter',
    color: 'forest',
    includes: ['6 especias esenciales en tarros de cristal', 'Guía completa del principiante', 'Tabla de equivalencias y sustituciones', 'Caja regalo con compartimentos'],
    perfectFor: ['Cocina diaria', 'Aprender a sazonar', 'Regalo para amantes de la cocina', 'Primeros pasos culinarios'],
    rating: 4.9,
    reviewCount: 6,
  },
];

const CONTENT_IMAGES = 'https://twidpdwinrndvvlujgij.supabase.co/storage/v1/object/public/content-images/solsazon-content-images';

export const bundles: Bundle[] = bundleFixtures.map((bundle) => ({
  ...bundle,
  image: `${CONTENT_IMAGES}/packs/${bundle.slug}-image.jpg`,
}));
